<template>
  <b-modal id="refill-bonus-modal"
           v-if="patient"
           @hide="onHide"
           :title="$t('bonus_adjustment')"
           centered
           hide-footer>
    <div class="row">
      <div class="col">
        <label class="form-label">{{ $t('bonuses') }}</label>
        <div class="emphasized-text">{{ formatCurrency(bonusForBranch) }}</div>
      </div>
    </div>
    <hr/>
    <div class="row align-items-end">
      <div class="col">
        <InputGroup type="number"
                    :label="$t('sum')"
                    :required="true"
                    v-model="amount"/>
        <ValidationError validationId="paid"/>
      </div>
      <div class="col">
        <div class="form-group">
          <b-dropdown right variant="link" no-caret>
            <template #button-content class="w-100">

              <a class="pointer position-relative btn-themed btn-success btn-themed-squared btn-process d-block w-100">{{ $t('process') }}</a>

            </template>
            <div class="pt-0">
              <button :disabled="loading"
                      @click="save(1)"
                      class="btn w-100 text-left">
                {{ $t('filling') }}
              </button>
              <button :disabled="loading"
                      @click="save(-1)"
                      class="btn w-100 text-left">
                {{ $t('write_off') }}
              </button>
            </div>
          </b-dropdown>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script setup>

import {useStore} from "vuex"
import InputGroup from "@/components/form/InputGroup"
import { EloquentService } from "@/services/api/eloquent.api.service"
import ValidationError from "@/components/form/ValidationError"
import {formatCurrency} from "@/extensions/filters/filters"
import {computed, getCurrentInstance, onBeforeMount, ref, watch} from "vue"
import {appendFormdata} from "@/extensions/prototypes/prototypes"

const amount = ref(0)
const store = useStore()
let bvModal = null

const loading = computed(() => store.state.dom.loading)
const patient = computed(() => store.state.patient.patient)
const branchId = computed(() => store.state.auth.branch)
const bonusForBranch = computed(() => {
  if(!patient.value) return 0
  return patient.value.total_bonuses
})

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})

const save = async (sign) => {
  let formData = new FormData()
  formData = appendFormdata(formData, {
    patient_id: patient.value.id,
    branch_id: branchId.value,
    value: Math.abs(amount.value) * sign
  })
  try {
    await EloquentService.create('bonus_manual_transaction', formData)
    store.dispatch('getPatient', patient.value.id).then()
    bvModal.hide('refill-bonus-modal')
    store.commit('incrementDataTableCounter')
  } catch (e) {
    console.log(e)
  }
}

const onHide = () => {
  amount.value = 0
}

watch(amount, (val) => {
  if(val < 0) {
    amount.value = Math.abs(val)
  }
})
</script>

<style scoped lang="scss">
.btn-success {
  height: 46px;
  line-height: 44px;
}
.dropdown {
  width: 100%;
}
@media screen and (max-width: 768px) {
  .btn-process {
    height: 32px;
    line-height: 30px;
  }
}
</style>
